/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_List_Gp_Createfirsttitle3Inputs */

const en_coinvestments_list_gp_createfirsttitle3 = /** @type {(inputs: Coinvestments_List_Gp_Createfirsttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first co-investment`)
};

/**
* | output |
* | --- |
* | "Create your first co-investment" |
*
* @param {Coinvestments_List_Gp_Createfirsttitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_list_gp_createfirsttitle3 = /** @type {((inputs?: Coinvestments_List_Gp_Createfirsttitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_List_Gp_Createfirsttitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_list_gp_createfirsttitle3(inputs)
});
export { coinvestments_list_gp_createfirsttitle3 as "coInvestments_list_gp_createFirstTitle" }